<template>
  <div class="max-h-[24px]">
    <button v-if="favoritedSitter" :aria-label="favoritedLabel" @click="unfavoriteSitter">
      <heart-icon color="#4B4C52" class="mt-auto mb-auto" />
    </button>
    <button v-else @click="favoriteSitter">
      <heart-outline-icon color="#4B4C52" class="mt-auto mb-auto" />
    </button>
  </div>
</template>

<script lang="ts">
import HeartIcon from '@/graphics/icons/HeartIcon.vue';
import HeartOutlineIcon from '@/graphics/icons/HeartOutlineIcon.vue';
import { ADD_FAVORITE_SITTER, REMOVE_FAVORITE_SITTER } from '@/graphql/provider/profile/queries';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'FavoriteSitterButton',
  components: { HeartIcon, HeartOutlineIcon },
  props: {
    favoritedSitter: {
      default: false,
      type: Boolean,
    },
    sitterAccountId: {
      type: String,
      required: true,
    },
  },
  computed: {
    favoritedLabel(): string {
      if (this.favoritedSitter) {
        return 'Unfavorite sitter';
      }
      return 'Favorite sitter';
    },
  },
  methods: {
    favoriteSitter() {
      this.$apollo
        .mutate({
          mutation: ADD_FAVORITE_SITTER,
          variables: {
            providerId: this.sitterAccountId,
          },
        })
        .then(() => {
          this.$emit('favoritedSitterChange', true);
          this.trackFavoriteEvent(true);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    unfavoriteSitter() {
      this.$apollo
        .mutate({
          mutation: REMOVE_FAVORITE_SITTER,
          variables: {
            providerId: this.sitterAccountId,
          },
        })
        .then(() => {
          this.$emit('favoritedSitterChange', false);
          this.trackFavoriteEvent(false);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    trackFavoriteEvent(isFavorited: boolean): void {
      const eventName = isFavorited ? 'Parent Profile Favorited Sitter' : 'Parent Profile Unfavorited Sitter';
      const eventProperties: any = {
        sitter_uuid: this.sitterAccountId,
      };
      sendSegmentEvent(eventName, eventProperties);
    },
  },
};
</script>
